import { UnsupportedBrowserBanner } from './UnsupportedBrowserBanner';

export default UnsupportedBrowserBanner;
